import React, { Component } from "react";
import { Select } from "antd";
import authActions from '../../actions/auth';
import { connect } from 'react-redux';
const Option = Select.Option;

let languageLocale = [
	{ lang: 'en', view: 'En' },
	{ lang: 'ru', view: 'Ru' },
];

class SwitchLanguageButton extends Component{
	
	onChange = (locale) => {
		let currentLanguage = languageLocale.find(language => language.lang === locale);
		authActions.languageSwitched(currentLanguage.lang);
	};
	
	render(){
		const { locale } = this.props;
		return(
			<Select
				className="language"
				defaultValue={locale}
				value={locale}
				onChange={this.onChange}
			>
				{languageLocale.map((language, i) => {
					return (
						<Option key={i}
						        value={language.lang}
						        title={language.view}
						>
							{language.view}
						</Option>);
				})}
			</Select>
		)
	}
}

const mapStateToProps = ({ user: { locale } }) => {
	return {
		locale
	};
};

export default connect(mapStateToProps)(SwitchLanguageButton);


// WEBPACK FOOTER //
// ./src/components/LangSwitcher/LangSwitcher.js